import React, { useEffect } from "react";
import { useWorkflowContext } from "screens/thread/WorkflowContextProvider";
import { useAddToCharliContext } from "screens/panels/addToCharli/AddToCharliWizard/AddToCharliProvider";
import { WorkflowPanel } from "./WorkflowPanel";
import { WorkflowPanel as WorkflowPanelV2 } from "screens/common/components/WorkflowSummary/v2/WorkflowPanel";
import { useFeatureFlags } from "hooks";

export const WorkflowPanelUser = () => {
  const { isWorkflow, isMessageId, onWorkflowPanelClose, isWorkflowPanelOpen, setWorkflowSummary, setWorkflow } = useWorkflowContext();
  const { isContentViewOpen } = useAddToCharliContext();
  const { workflow_summary_2: hasWorkflowSummaryV2 } = useFeatureFlags();
  const [isLoadingWorkflow, setIsLoadingWorkflow] = React.useState(true);

  useEffect(() => {
    if (isWorkflow && Object.keys(isWorkflow).length > 0) {
      setIsLoadingWorkflow(false);
    }

    const timeoutId = setTimeout(() => {
      setIsLoadingWorkflow(false);
    }, 2000);

    return () => clearTimeout(timeoutId);
  }, [isWorkflow]);

  return hasWorkflowSummaryV2 ? (
    <WorkflowPanelV2
      isOpen={isWorkflowPanelOpen}
      onClose={() => {
        setWorkflow();
        setWorkflowSummary([]);

        onWorkflowPanelClose();
      }}
      workflow={isWorkflow}
      isLoadingWorkflow={isLoadingWorkflow}
      isMessageId={isMessageId}
    />
  ) : (
    <WorkflowPanel
      isOpen={isWorkflowPanelOpen}
      onClose={() => {
        onWorkflowPanelClose();
      }}
      workflow={isWorkflow}
      isContentViewOpen={isContentViewOpen}
      isLoadingWorkflow={isLoadingWorkflow}
      isMessageId={isMessageId}
    />
  );
};
